import { useContext, useEffect, useState, useCallback } from 'react';
import { UserContext } from '#src/context/UserContext.js';
import { APIGetWFSAccess, APICreateWFSAccess, APIUpdateWFSAccess } from '#src/api/wfs/WFS.js';
import { MdContentCopy,MdCheck } from "react-icons/md";

export const WfsProfileManagement = () => {
    const { user } = useContext(UserContext);
    const [username, setUsername] = useState('');
    const [copied, setCopied] = useState(null);
    const [password, setPassword] = useState('');
    const [accessId, setAccessId] = useState(null);

    function generatePassword(length = 25) {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%-/&*()_+[]{}|,.<>?";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    }

    const saveWFSAccess = useCallback(async (wfsAccessData) => {

        try {
            if (accessId) {
                // Update existing WFS access
                await APIUpdateWFSAccess({ ...wfsAccessData, id: accessId });
            } else {
                // Create new WFS access
                const newAccess = await APICreateWFSAccess(wfsAccessData);
                setAccessId(newAccess.id);
            }
        } catch (error) {
            console.error('Error saving WFS access:', error);
        }
    }, [accessId]);

    // Function to generate a random username and password
    const generateCredentials = useCallback(async () => {
        const newUsername = `user_${Math.random().toString(36).substring(2, 14)}`;
        const newPassword = generatePassword();
        setUsername(newUsername);
        setPassword(newPassword);

        const wfsAccessData = {
            type: 'company',
            entity_id: user.companyId,
            username: newUsername,
            password: newPassword,
        };
        await saveWFSAccess(wfsAccessData);
    }, [saveWFSAccess, user.companyId]);

    // Fetch WFS access details
    const fetchWFSAccess = useCallback(async () => {


        try {
            const access = await APIGetWFSAccess('company', user.companyId);

            if (access) {
                setUsername(access.username);
                setPassword(access.password);
                setAccessId(access.id);
            } else {
                // Generate new credentials if no access exists
                generateCredentials();
            }
        } catch (error) {
            console.error('Error fetching WFS access:', error);
        }
    }, [generateCredentials, user.companyId]);


    useEffect(() => {
        fetchWFSAccess();
    }, [fetchWFSAccess]);





    return (
        <div className="border border-gray-500 rounded-lg bg-white w-full p-6 mb-12">
            <div className="flex justify-between flex justify-between rounded pb-5 ">
                <h1 className="text-lg font-semibold text-gray-900 mb-4">WFS-Zugang</h1>
                <button
                    type="button"
                    onClick={generateCredentials}
                    className="px-4 py-2 bg-gray-600 text-sm font-bold text-white rounded-md hover:bg-gray-600"
                >
                    {typeof username !== "undefined" ? "Zugangsdaten  ändern"  : "Aktivieren"}
                </button>
            </div>
            <div className={"pt-2 pb-6 text-gray-900/60 text-sm"}>
                XPLANUNG24 ermöglicht es Ihnen sämtliche Pläne welche Ihrem Account zugefügt wurden per WFS abzurufen.
            </div>

            <div className="mb-4 items-center flex">
                <div className="block text-sm font-medium w-[150px] ">Benutzername:</div>
                <div className="text-gray-900/60  sm:text-sm ">
                    {username}
                </div>
            </div>
            <div className="mb-4 items-center flex">
                <div className="block text-sm font-medium w-[150px] ">Passwort:</div>
                <div className="text-gray-900/60  sm:text-sm ">
                    {password}
                </div>
            </div>

            <div className="mt-4 flex">
                <div className="block text-sm font-medium flex-shrink-0 w-[150px]">WFS-Server:</div>
                <div className="flex items-center gap-2 bg-gray-200 relative flex-shrink p-4 rounded-xl mt-2">
                    <span className="text-sm text-gray-900/60 flex-shrink break-all pr-5 ">
                        {`http://localhost:3004/dev/wfs/1.0/company/${user.companyId}?request=GetCapabilities`}
                    </span>
                    <button
                        type="button"
                        onClick={() => {navigator.clipboard.writeText(`http://localhost:3004/dev/wfs/1.0/company/${user.companyId}?request=GetCapabilities`); setCopied(true)}}
                        className="p-1.5 bg-gray-600 text-white absolute right-2 top-2 rounded-md hover:bg-gray-700 text-xs"
                    >
                        {(copied === null) ? (<MdContentCopy />) : (<MdCheck className={"text-green"} />)}
                    </button>
                </div>
            </div>
        </div>
    );
};
